export const DEACTIVATED_ACCOUNT_MESSAGE =
  'Your account has been deactivated. Please contact your administrator.';

const DISABLED_STATE = '(?:deactivated|inactive|disabled|deleted)';
const ACCOUNT_SUBJECT = '(?:account|user)';
const ACCOUNT_DISABLED_PATTERNS = [
  new RegExp(`${ACCOUNT_SUBJECT}[^.]*${DISABLED_STATE}`, 'i'),
  new RegExp(`${DISABLED_STATE}[^.]*${ACCOUNT_SUBJECT}`, 'i'),
];

const extractMessage = (payload: unknown): string => {
  if (typeof payload === 'string') return payload;
  if (!payload || typeof payload !== 'object') return '';

  const data = payload as Record<string, unknown>;
  for (const key of ['detail', 'message', 'error']) {
    const value = data[key];
    const message = extractMessage(value);
    if (message) return message;
  }
  return '';
};

export const getDeactivatedAccountMessage = (payload: unknown): string => {
  const responseMessage = extractMessage(payload);
  return ACCOUNT_DISABLED_PATTERNS.some(pattern => pattern.test(responseMessage))
    ? DEACTIVATED_ACCOUNT_MESSAGE
    : '';
};

export const storeAuthRedirectNotice = (
  storage: Storage,
  responsePayload: unknown,
): string => {
  const accountMessage = getDeactivatedAccountMessage(responsePayload);

  if (accountMessage) {
    storage.setItem('auth_session_message', accountMessage);
    storage.removeItem('auth_session_expired');
    return accountMessage;
  }

  // Preserve a more specific account-state message set by another concurrent
  // request instead of replacing it with the generic session-expired notice.
  if (!storage.getItem('auth_session_message')) {
    storage.setItem('auth_session_expired', '1');
  }
  return '';
};

export const consumeAuthRedirectNotice = (storage: Storage): string => {
  const accountMessage = storage.getItem('auth_session_message');
  if (accountMessage) {
    storage.removeItem('auth_session_message');
    storage.removeItem('auth_session_expired');
    return accountMessage;
  }

  if (storage.getItem('auth_session_expired') === '1') {
    storage.removeItem('auth_session_expired');
    return 'Your session expired. Please sign in again.';
  }

  return '';
};

export const redirectToLoginAfterAuthFailure = (
  responsePayload: unknown,
  target = '/login',
): void => {
  if (typeof window === 'undefined') return;

  try {
    storeAuthRedirectNotice(window.sessionStorage, responsePayload);
    window.sessionStorage.removeItem('auth_token');
    window.sessionStorage.removeItem('auth_user');
  } catch {
    // Ignore storage errors; redirect still handles the session reset.
  }

  if (window.location.pathname !== target) {
    window.location.assign(target);
  }
};
